import Style from "./WhatsNew.module.scss";
import { Link } from "react-router-dom";
import IcoMoon from "../Layouts/IcoMooon";
import { useDimensions } from "../../logic/Dimensions";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ReactHtmlParser from "react-html-parser";
import { useTranslation } from "react-i18next";

gsap.registerPlugin(ScrollTrigger);

const WhatsNew = ({ mediaData, selectedMedia }) => {
  const { width } = useDimensions();
  const { t } = useTranslation(["common"]);
  return (
    <div className={`${Style.whatsnewsec} ${Style.loaded}`}>
      <div className="container ">
        <div className={Style.secheader}>
          <header className={Style.sectitle}>
            <h2>Whats New</h2>
          </header>
          {width >= 768 && (
            <Link to="/media" className={`arw-link ${Style.viewall}`}>
              <span>
                <IcoMoon icon="arrow-right" size={12} />
              </span>
              {t("buttonViewAll")}
            </Link>
          )}
        </div>

        <div className={`${Style.postlistwrap} blog-el`}>
          {mediaData?.[selectedMedia]?.details?.blog_list &&
            mediaData?.[selectedMedia]?.details?.blog_list?.length > 0 &&
            mediaData?.[selectedMedia]?.details?.blog_list
              .slice(0, 3)
              ?.map((value, i) => {
                return (
                  <div key={i} className={"blog-el"}>
                    {value?.categories !== "Gallery" && (
                      <Link
                        to={`/media-detail/${value?.categories_ids}/${value?.ID}`}
                        className={Style.newitem}
                      >
                        {value?.post_thumbnail_url && (
                          <figure className={Style.postimg}>
                            <img src={value?.post_small_thumbnail_url} alt="whats new" />
                          </figure>
                        )}
                        <div className={Style.details}>
                          <div className={Style.postype}>
                            {value?.categories}
                          </div>
                          <header className={Style.postitle}>
                            {value?.post_title}
                          </header>
                          {!value?.post_thumbnail_url && (
                            <div className={Style.cntsec}>
                              <p>{ReactHtmlParser(value?.post_content)}</p>
                            </div>
                          )}

                          <div className={Style.postdate}>
                            {value?.post_date_beautiful}
                          </div>
                        </div>
                      </Link>
                    )}
                  </div>
                );
              })}
        </div>

        {width < 768 && (
          <div className={Style.btnwrap}>
            <Link className={`btn btn-brdr ${Style.btn}`} to="/media">
              <span>{t("buttonViewAll")}</span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatsNew;
